import {Icon} from '@bitstillery/common/components/portal'
import {MithrilComponent} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import {format_iso_to_date} from '@bitstillery/common/lib/format'
import {$t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import {$s} from '@/app'
import {filters} from '@/components/pages/offers/offer_list'

export class IncentivePersonalOffer extends MithrilComponent {
    view(_vn: m.Vnode) {
        if (!filters.offer.selection || $s.offers.personal.length === 0 || filters.offer.selection === 'SPECIALS') {
            return
        }
        const active_personal_offer = $s.offers.personal.find((i) => i.hash === filters.offer.selection)

        return (
            <div
                className={classes('c-incentive-personal-offer', {
                    inactive: !active_personal_offer,
                })}
            >
                <Icon name='specialOffers' size='xl' type='unset' />
                <div className='personal-text'>
                    {(() => {
                        if (!active_personal_offer) {
                            return $t('offer.personal_not_found')
                        }
                        return [
                            <div>{active_personal_offer.title}</div>,
                            <div>
                                {$t('offer.valid_until', {
                                    date: format_iso_to_date(active_personal_offer.end_date, $s.language),
                                    interpolation: {escapeValue: false},
                                })}
                            </div>,
                        ]
                    })()}
                </div>
            </div>
        )
    }
}
